module.exports = __webpack_public_path__ + "media/img/vca/prizes/feast-366bd7adf69da0ba79029f9926eed1fa.png";